import { createFileRoute } from "@tanstack/react-router";
import { Profile } from "../../features/account/profile";

export const Route = createFileRoute("/_authed/account/profile")({ component: Profile });
